module.exports = __webpack_public_path__ + "static/media/Forward.05a3dedd.svg";